<template>
  <!--isSortable-->
  <grid-component
      isResizable
      isReorderable
      isSortable
      :canEdit="checkClaim(CAN_EDIT_SALES_ORDER)"
      :canDelete="checkClaim(CAN_DELETE_SALES_ORDERS)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="fieldsByGridId"
      :onEdit="pushToDetails"
      :handleRowClick="onRowClick"
      :navigationField="navigationFieldByGridId"
      :sortBy="gridInfo.sortBy"
      :sortOrder="gridInfo.sortOrder"
      :sortMethod="onSort"
      :styleCustom="'height: 160px'"
    />
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { GRID_PAGE_SIZES, PAGE_SIZE, GRID_ID } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from '@/pages/SalesOrders/fields';
import lineFields from './fields';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    purchaseOrderLineId: {
      type: [String, Number],
      default: 0,
    },
    salesOrderLineId: {
      type: [Number, String],
      default: 0
    },
    isParentList: {
      type: Boolean,
      default: false,
    },
    salesOrdersParentList: {
      type: Array,
      default: () => []
    },
    gridId: {
      type: String,
      default: GRID_ID.SALES_ORDERS
    },
    companyId: {
      type: [String, Number],
      default: 0
    },
    dataBy: {
      type: String,
      default: ''
    },
    isPartTab:{
      type: Boolean,
      default: false,
    },
    partId: {
      type: [Number, String],
      default: 0
    },
  },
  data() {
    return {
      filtersVisible: false,
      fields: gridFields,
      lineFields,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      filters: {}
    };
  },
  computed: {
    ...mapState('salesOrders', [
      'salesordersList',
      'pageInfo',
      'searchQuery'
    ]),
    ...mapGetters('salesOrders', ['salesOrdersCustom', 'salesOrdersFiltered']),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('salesOrderLines', ['salesOrderLinesByPart']),
    ...mapGetters('shippingReceiving', ['soPageInfo']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      let itemData = [];
      if (this.isParentList) {
        itemData = this.salesOrdersParentList;
      } else if (['salesOrder'].includes(this.dataBy) || this.salesOrderLineId) {
        itemData = this.salesOrdersCustom;
      } else if (this.purchaseOrderLineId) {
        itemData = this.salesOrdersCustom;
      } else if (this.isPartTab && this.salesOrderLinesByPart) {
        itemData = this.salesOrderLinesByPart;
      }else {
        itemData = this.salesOrdersFiltered;
      }
      return (itemData.length > 0) ? itemData.map((salesorder) => ({ ...salesorder, selected: salesorder.id === this.selectedRowItemId })) : []
    },
    fieldsByGridId() {
      return (this.gridId == GRID_ID.SALES_ORDER_LINES_TAB_GRID) ? this.lineFields : this.fields;
    },
    navigationFieldByGridId() {
      return (this.gridId == GRID_ID.SALES_ORDER_LINES_TAB_GRID) ? 'salesOrderId' : 'id';
    },
    gridInfo() {
      return this.isParentList ? this.soPageInfo : {sortBy: null, sortOrder: null}
    }
  },
  methods: {
    ...mapActions('salesOrders', ['getAll', 'deleteSalesOrder', 'getByPurchaseOrderLineId', 'getBySalesOrderLineId', 'getSalesOrderByFilter']),
    ...mapActions('account', ['saveGridSettings']),
    ...mapMutations('salesOrders', ['setItem']),
    ...mapActions('salesOrderLines', ['getSalesOrderLinesByPart']),

    ...mapActions('account', ['saveGridSettings']),
    onSort($e) {
      if (this.isParentList) {
        this.$emit('onSort', $e)
      }
    },
    pageFunction: function(e) {
      console.log(e);
    },
    pushToDetails(row) {
      const paramId = row[this.navigationFieldByGridId];

      this.$router.push({
        name: 'salesorders.edit',
        params: { id: paramId },
      });
    },
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      this.$emit('selectedSalesOrder', row.dataItem);
      // const { id, detailsVisible } = row.dataItem;
      // this.select({ id, isChecked: !detailsVisible });
    },
    async onDelete(salesOrder) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete Sales Order #${salesOrder.id}?`});
      if (deleteConfirmed) {
        await this.deleteSalesOrder(salesOrder.id)
        this.getAll({});
      }
    },
    async getSalesOrdersByPoLine() {
      await this.getByPurchaseOrderLineId(this.purchaseOrderLineId);
    },
    async getSalesOrdersBySoLine() {
      if (this.salesOrderLineId != null) {
        await this.getBySalesOrderLineId(this.salesOrderLineId);
      } else {
        /*this.setSalesOrdersCustom([]);*/
        this.setItem({ resource: 'salesOrdersCustom', payload: [] });
      }
    },
    async getSalesOrdersFiltered() {
      await this.getSalesOrderByFilter(this.filters);
    }
  },
  watch: {
    purchaseOrderLineId() { this.getSalesOrdersByPoLine() },
    salesOrderLineId() { this.getSalesOrdersBySoLine() },
    partId() {this.getSalesOrderLinesByPart(this.partId)}
  },
  async mounted() {
    // this.clearSalesOrdersItems();
    if (this.purchaseOrderLineId) { this.getSalesOrdersByPoLine() }
    if (this.salesOrderLineId) { this.getSalesOrdersBySoLine() }
    if (this.companyId) {
      this.filters.companyId = this.companyId;
      await this.getSalesOrdersFiltered();
    }

    if(this.isPartTab && this.partId > 0){
      await this.getSalesOrderLinesByPart(this.partId)
    }

    if (['salesOrder'].includes(this.dataBy) && !this.salesOrderLineId) {
      /*this.setSalesOrdersCustom([]);*/
      this.setItem({ resource: 'salesOrdersCustom', payload: [] });
    }
  },
};
</script>

<style>
#KendoGrid .k-virtual-scrollable-wrap table
{
    min-width: 800px;
}
</style>
